// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4914":"95b9f002","5043":"a4fc9f91","5674":"8c7658f9","5931":"e31dd909","7950":"e88b91b4"}[chunkId] + ".chunk.js";
};